import React from 'react'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../redux/userRedux'
import Announcement from '../components/Announcement';
import Navbar from "../components/Navbar"
import styled from 'styled-components';

const Parent=styled.div`
    display: grid;
    grid-template-columns: 20%  50%;
    
`
const UserPic=styled.div`
    width:100%;
    background-color: teal;
    margin: .3rem .5rem;
    border-radius: 10px;
`
const UserDetails=styled.div`
    padding: .8rem;
    margin: 1rem;
    background-color: #8f4567;
    color: white;
    font-weight: 500;

`


const User= () => {
    const user=useSelector(currentUserSelector);
    // console.log({user});
    const {img,firstName,lastName,username,emailId}=user?.toBeSent
  return (
    <div>
      <Announcement/>
      <Navbar/>
      <Parent>
        <UserPic>
                <img src={img || "https://i.ibb.co/C29xkx6/pngegg-2.png"} alt="" style={{width:"100%",height:"100%",objectFit:"contain"}} />
        </UserPic>
        <UserDetails>
            <div>
              First name  - {firstName || "Not Available"}
            </div>
               <div>
              Last name -  {lastName || "Not Available"}
               </div>
               <div>
               Username -  {username}
               </div>
               <div>
              Email -   {emailId}
               </div>
               <div>
              Delivery Address -   {"Not Available"}
               </div>
               <div>
              Mobile -   {"Not Available"}
               </div>
               <div>
              Alternate mobile  -   {"Not Available"}
               </div>
        </UserDetails>
      </Parent>
    </div>
  )
}

export default User
